import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
let initialized = false;

/**
 * Lightweight Google Analytics 4 integration.
 * Loads gtag.js once and reports a page_view on every React Router navigation.
 * No-ops if REACT_APP_GA_MEASUREMENT_ID is not set.
 */
export default function useGoogleAnalytics() {
  const location = useLocation();

  // One-time gtag.js bootstrap
  useEffect(() => {
    if (!GA_ID || initialized) return;
    initialized = true;

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag("js", new Date());
    // Disable automatic page_view — we send manually on route change
    gtag("config", GA_ID, { send_page_view: false });
  }, []);

  // Per-route page_view
  useEffect(() => {
    if (!GA_ID || !window.gtag) return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);
}
